// source: common/due_date_reminder.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.common.DUE_DATE_REMINDER_OVERDUE_FREQUENCY', null, global);
goog.exportSymbol('proto.common.DUE_DATE_REMINDER_RECIPIENT_STATUS', null, global);
goog.exportSymbol('proto.common.DueDateReminderRecipient', null, global);
goog.exportSymbol('proto.common.DueDateReminderRecipient.RecipientCase', null, global);
goog.exportSymbol('proto.common.DueDateReminderRecipientOption', null, global);
goog.exportSymbol('proto.common.DueDateReminderRecipientOptions', null, global);
goog.exportSymbol('proto.common.DueDateReminders', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.DueDateReminderRecipient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.common.DueDateReminderRecipient.oneofGroups_);
};
goog.inherits(proto.common.DueDateReminderRecipient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.DueDateReminderRecipient.displayName = 'proto.common.DueDateReminderRecipient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.DueDateReminderRecipientOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.DueDateReminderRecipientOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.DueDateReminderRecipientOption.displayName = 'proto.common.DueDateReminderRecipientOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.DueDateReminderRecipientOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.DueDateReminderRecipientOptions.repeatedFields_, null);
};
goog.inherits(proto.common.DueDateReminderRecipientOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.DueDateReminderRecipientOptions.displayName = 'proto.common.DueDateReminderRecipientOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.DueDateReminders = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.DueDateReminders.repeatedFields_, null);
};
goog.inherits(proto.common.DueDateReminders, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.DueDateReminders.displayName = 'proto.common.DueDateReminders';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.common.DueDateReminderRecipient.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.common.DueDateReminderRecipient.RecipientCase = {
  RECIPIENT_NOT_SET: 0,
  USER_ID: 1,
  USER_GROUP_ID: 2,
  VENDOR_USER_ID: 3
};

/**
 * @return {proto.common.DueDateReminderRecipient.RecipientCase}
 */
proto.common.DueDateReminderRecipient.prototype.getRecipientCase = function() {
  return /** @type {proto.common.DueDateReminderRecipient.RecipientCase} */(jspb.Message.computeOneofCase(this, proto.common.DueDateReminderRecipient.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.DueDateReminderRecipient.prototype.toObject = function(opt_includeInstance) {
  return proto.common.DueDateReminderRecipient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.DueDateReminderRecipient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminderRecipient.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userGroupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    vendorUserId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.DueDateReminderRecipient}
 */
proto.common.DueDateReminderRecipient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.DueDateReminderRecipient;
  return proto.common.DueDateReminderRecipient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.DueDateReminderRecipient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.DueDateReminderRecipient}
 */
proto.common.DueDateReminderRecipient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.DueDateReminderRecipient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.DueDateReminderRecipient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.DueDateReminderRecipient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminderRecipient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.common.DueDateReminderRecipient.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminderRecipient} returns this
 */
proto.common.DueDateReminderRecipient.prototype.setUserId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.common.DueDateReminderRecipient.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.DueDateReminderRecipient} returns this
 */
proto.common.DueDateReminderRecipient.prototype.clearUserId = function() {
  return jspb.Message.setOneofField(this, 1, proto.common.DueDateReminderRecipient.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.DueDateReminderRecipient.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string user_group_id = 2;
 * @return {string}
 */
proto.common.DueDateReminderRecipient.prototype.getUserGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminderRecipient} returns this
 */
proto.common.DueDateReminderRecipient.prototype.setUserGroupId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.common.DueDateReminderRecipient.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.DueDateReminderRecipient} returns this
 */
proto.common.DueDateReminderRecipient.prototype.clearUserGroupId = function() {
  return jspb.Message.setOneofField(this, 2, proto.common.DueDateReminderRecipient.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.DueDateReminderRecipient.prototype.hasUserGroupId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string vendor_user_id = 3;
 * @return {string}
 */
proto.common.DueDateReminderRecipient.prototype.getVendorUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminderRecipient} returns this
 */
proto.common.DueDateReminderRecipient.prototype.setVendorUserId = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.common.DueDateReminderRecipient.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.DueDateReminderRecipient} returns this
 */
proto.common.DueDateReminderRecipient.prototype.clearVendorUserId = function() {
  return jspb.Message.setOneofField(this, 3, proto.common.DueDateReminderRecipient.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.DueDateReminderRecipient.prototype.hasVendorUserId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.DueDateReminderRecipientOption.prototype.toObject = function(opt_includeInstance) {
  return proto.common.DueDateReminderRecipientOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.DueDateReminderRecipientOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminderRecipientOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipient: (f = msg.getRecipient()) && proto.common.DueDateReminderRecipient.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    statusReason: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.DueDateReminderRecipientOption}
 */
proto.common.DueDateReminderRecipientOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.DueDateReminderRecipientOption;
  return proto.common.DueDateReminderRecipientOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.DueDateReminderRecipientOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.DueDateReminderRecipientOption}
 */
proto.common.DueDateReminderRecipientOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.DueDateReminderRecipient;
      reader.readMessage(value,proto.common.DueDateReminderRecipient.deserializeBinaryFromReader);
      msg.setRecipient(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {!proto.common.DUE_DATE_REMINDER_RECIPIENT_STATUS} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.DueDateReminderRecipientOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.DueDateReminderRecipientOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.DueDateReminderRecipientOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminderRecipientOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.DueDateReminderRecipient.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStatusReason();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional DueDateReminderRecipient recipient = 1;
 * @return {?proto.common.DueDateReminderRecipient}
 */
proto.common.DueDateReminderRecipientOption.prototype.getRecipient = function() {
  return /** @type{?proto.common.DueDateReminderRecipient} */ (
    jspb.Message.getWrapperField(this, proto.common.DueDateReminderRecipient, 1));
};


/**
 * @param {?proto.common.DueDateReminderRecipient|undefined} value
 * @return {!proto.common.DueDateReminderRecipientOption} returns this
*/
proto.common.DueDateReminderRecipientOption.prototype.setRecipient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.DueDateReminderRecipientOption} returns this
 */
proto.common.DueDateReminderRecipientOption.prototype.clearRecipient = function() {
  return this.setRecipient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.DueDateReminderRecipientOption.prototype.hasRecipient = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.common.DueDateReminderRecipientOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminderRecipientOption} returns this
 */
proto.common.DueDateReminderRecipientOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.common.DueDateReminderRecipientOption.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminderRecipientOption} returns this
 */
proto.common.DueDateReminderRecipientOption.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional DUE_DATE_REMINDER_RECIPIENT_STATUS status = 4;
 * @return {!proto.common.DUE_DATE_REMINDER_RECIPIENT_STATUS}
 */
proto.common.DueDateReminderRecipientOption.prototype.getStatus = function() {
  return /** @type {!proto.common.DUE_DATE_REMINDER_RECIPIENT_STATUS} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.DUE_DATE_REMINDER_RECIPIENT_STATUS} value
 * @return {!proto.common.DueDateReminderRecipientOption} returns this
 */
proto.common.DueDateReminderRecipientOption.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string status_reason = 5;
 * @return {string}
 */
proto.common.DueDateReminderRecipientOption.prototype.getStatusReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminderRecipientOption} returns this
 */
proto.common.DueDateReminderRecipientOption.prototype.setStatusReason = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.DueDateReminderRecipientOptions.repeatedFields_ = [1,2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.DueDateReminderRecipientOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.common.DueDateReminderRecipientOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.DueDateReminderRecipientOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminderRecipientOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.common.DueDateReminderRecipientOption.toObject, includeInstance),
    userGroupsList: jspb.Message.toObjectList(msg.getUserGroupsList(),
    proto.common.DueDateReminderRecipientOption.toObject, includeInstance),
    vendorContactsList: jspb.Message.toObjectList(msg.getVendorContactsList(),
    proto.common.DueDateReminderRecipientOption.toObject, includeInstance),
    selectedList: jspb.Message.toObjectList(msg.getSelectedList(),
    proto.common.DueDateReminderRecipientOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.DueDateReminderRecipientOptions}
 */
proto.common.DueDateReminderRecipientOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.DueDateReminderRecipientOptions;
  return proto.common.DueDateReminderRecipientOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.DueDateReminderRecipientOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.DueDateReminderRecipientOptions}
 */
proto.common.DueDateReminderRecipientOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.DueDateReminderRecipientOption;
      reader.readMessage(value,proto.common.DueDateReminderRecipientOption.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    case 2:
      var value = new proto.common.DueDateReminderRecipientOption;
      reader.readMessage(value,proto.common.DueDateReminderRecipientOption.deserializeBinaryFromReader);
      msg.addUserGroups(value);
      break;
    case 3:
      var value = new proto.common.DueDateReminderRecipientOption;
      reader.readMessage(value,proto.common.DueDateReminderRecipientOption.deserializeBinaryFromReader);
      msg.addVendorContacts(value);
      break;
    case 4:
      var value = new proto.common.DueDateReminderRecipientOption;
      reader.readMessage(value,proto.common.DueDateReminderRecipientOption.deserializeBinaryFromReader);
      msg.addSelected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.DueDateReminderRecipientOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.DueDateReminderRecipientOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.DueDateReminderRecipientOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminderRecipientOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.common.DueDateReminderRecipientOption.serializeBinaryToWriter
    );
  }
  f = message.getUserGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.common.DueDateReminderRecipientOption.serializeBinaryToWriter
    );
  }
  f = message.getVendorContactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.common.DueDateReminderRecipientOption.serializeBinaryToWriter
    );
  }
  f = message.getSelectedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.common.DueDateReminderRecipientOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DueDateReminderRecipientOption users = 1;
 * @return {!Array<!proto.common.DueDateReminderRecipientOption>}
 */
proto.common.DueDateReminderRecipientOptions.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.common.DueDateReminderRecipientOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.DueDateReminderRecipientOption, 1));
};


/**
 * @param {!Array<!proto.common.DueDateReminderRecipientOption>} value
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
*/
proto.common.DueDateReminderRecipientOptions.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.DueDateReminderRecipientOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.DueDateReminderRecipientOption}
 */
proto.common.DueDateReminderRecipientOptions.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.DueDateReminderRecipientOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
 */
proto.common.DueDateReminderRecipientOptions.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};


/**
 * repeated DueDateReminderRecipientOption user_groups = 2;
 * @return {!Array<!proto.common.DueDateReminderRecipientOption>}
 */
proto.common.DueDateReminderRecipientOptions.prototype.getUserGroupsList = function() {
  return /** @type{!Array<!proto.common.DueDateReminderRecipientOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.DueDateReminderRecipientOption, 2));
};


/**
 * @param {!Array<!proto.common.DueDateReminderRecipientOption>} value
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
*/
proto.common.DueDateReminderRecipientOptions.prototype.setUserGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.DueDateReminderRecipientOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.DueDateReminderRecipientOption}
 */
proto.common.DueDateReminderRecipientOptions.prototype.addUserGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.DueDateReminderRecipientOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
 */
proto.common.DueDateReminderRecipientOptions.prototype.clearUserGroupsList = function() {
  return this.setUserGroupsList([]);
};


/**
 * repeated DueDateReminderRecipientOption vendor_contacts = 3;
 * @return {!Array<!proto.common.DueDateReminderRecipientOption>}
 */
proto.common.DueDateReminderRecipientOptions.prototype.getVendorContactsList = function() {
  return /** @type{!Array<!proto.common.DueDateReminderRecipientOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.DueDateReminderRecipientOption, 3));
};


/**
 * @param {!Array<!proto.common.DueDateReminderRecipientOption>} value
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
*/
proto.common.DueDateReminderRecipientOptions.prototype.setVendorContactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.common.DueDateReminderRecipientOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.DueDateReminderRecipientOption}
 */
proto.common.DueDateReminderRecipientOptions.prototype.addVendorContacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.common.DueDateReminderRecipientOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
 */
proto.common.DueDateReminderRecipientOptions.prototype.clearVendorContactsList = function() {
  return this.setVendorContactsList([]);
};


/**
 * repeated DueDateReminderRecipientOption selected = 4;
 * @return {!Array<!proto.common.DueDateReminderRecipientOption>}
 */
proto.common.DueDateReminderRecipientOptions.prototype.getSelectedList = function() {
  return /** @type{!Array<!proto.common.DueDateReminderRecipientOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.DueDateReminderRecipientOption, 4));
};


/**
 * @param {!Array<!proto.common.DueDateReminderRecipientOption>} value
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
*/
proto.common.DueDateReminderRecipientOptions.prototype.setSelectedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.common.DueDateReminderRecipientOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.DueDateReminderRecipientOption}
 */
proto.common.DueDateReminderRecipientOptions.prototype.addSelected = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.common.DueDateReminderRecipientOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.DueDateReminderRecipientOptions} returns this
 */
proto.common.DueDateReminderRecipientOptions.prototype.clearSelectedList = function() {
  return this.setSelectedList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.DueDateReminders.repeatedFields_ = [2,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.DueDateReminders.prototype.toObject = function(opt_includeInstance) {
  return proto.common.DueDateReminders.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.DueDateReminders} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminders.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    beforeDaysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    overdueFrequency: jspb.Message.getFieldWithDefault(msg, 3, 0),
    timezone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    recipientsList: jspb.Message.toObjectList(msg.getRecipientsList(),
    proto.common.DueDateReminderRecipient.toObject, includeInstance),
    version: jspb.Message.getFieldWithDefault(msg, 6, 0),
    cronExpression: jspb.Message.getFieldWithDefault(msg, 7, ""),
    nextReminderAt: (f = msg.getNextReminderAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.DueDateReminders}
 */
proto.common.DueDateReminders.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.DueDateReminders;
  return proto.common.DueDateReminders.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.DueDateReminders} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.DueDateReminders}
 */
proto.common.DueDateReminders.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBeforeDays(values[i]);
      }
      break;
    case 3:
      var value = /** @type {!proto.common.DUE_DATE_REMINDER_OVERDUE_FREQUENCY} */ (reader.readEnum());
      msg.setOverdueFrequency(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 5:
      var value = new proto.common.DueDateReminderRecipient;
      reader.readMessage(value,proto.common.DueDateReminderRecipient.deserializeBinaryFromReader);
      msg.addRecipients(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVersion(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCronExpression(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextReminderAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.DueDateReminders.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.DueDateReminders.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.DueDateReminders} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.DueDateReminders.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getBeforeDaysList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getOverdueFrequency();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.common.DueDateReminderRecipient.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCronExpression();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNextReminderAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.common.DueDateReminders.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated int32 before_days = 2;
 * @return {!Array<number>}
 */
proto.common.DueDateReminders.prototype.getBeforeDaysList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.setBeforeDaysList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.addBeforeDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.clearBeforeDaysList = function() {
  return this.setBeforeDaysList([]);
};


/**
 * optional DUE_DATE_REMINDER_OVERDUE_FREQUENCY overdue_frequency = 3;
 * @return {!proto.common.DUE_DATE_REMINDER_OVERDUE_FREQUENCY}
 */
proto.common.DueDateReminders.prototype.getOverdueFrequency = function() {
  return /** @type {!proto.common.DUE_DATE_REMINDER_OVERDUE_FREQUENCY} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.DUE_DATE_REMINDER_OVERDUE_FREQUENCY} value
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.setOverdueFrequency = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string timezone = 4;
 * @return {string}
 */
proto.common.DueDateReminders.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated DueDateReminderRecipient recipients = 5;
 * @return {!Array<!proto.common.DueDateReminderRecipient>}
 */
proto.common.DueDateReminders.prototype.getRecipientsList = function() {
  return /** @type{!Array<!proto.common.DueDateReminderRecipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.DueDateReminderRecipient, 5));
};


/**
 * @param {!Array<!proto.common.DueDateReminderRecipient>} value
 * @return {!proto.common.DueDateReminders} returns this
*/
proto.common.DueDateReminders.prototype.setRecipientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.common.DueDateReminderRecipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.DueDateReminderRecipient}
 */
proto.common.DueDateReminders.prototype.addRecipients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.common.DueDateReminderRecipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional int64 version = 6;
 * @return {number}
 */
proto.common.DueDateReminders.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string cron_expression = 7;
 * @return {string}
 */
proto.common.DueDateReminders.prototype.getCronExpression = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.setCronExpression = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp next_reminder_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.common.DueDateReminders.prototype.getNextReminderAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.common.DueDateReminders} returns this
*/
proto.common.DueDateReminders.prototype.setNextReminderAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.DueDateReminders} returns this
 */
proto.common.DueDateReminders.prototype.clearNextReminderAt = function() {
  return this.setNextReminderAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.DueDateReminders.prototype.hasNextReminderAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * @enum {number}
 */
proto.common.DUE_DATE_REMINDER_OVERDUE_FREQUENCY = {
  OVERDUE_FREQUENCY_NONE: 0,
  OVERDUE_FREQUENCY_DAILY: 1,
  OVERDUE_FREQUENCY_WEEKLY: 2
};

/**
 * @enum {number}
 */
proto.common.DUE_DATE_REMINDER_RECIPIENT_STATUS = {
  RECIPIENT_STATUS_UNSPECIFIED: 0,
  RECIPIENT_STATUS_AVAILABLE: 1,
  RECIPIENT_STATUS_PENDING_ACCESS: 2,
  RECIPIENT_STATUS_NOT_READY: 3,
  RECIPIENT_STATUS_NO_ACCESS: 4,
  RECIPIENT_STATUS_NO_ELIGIBLE_MEMBERS: 5,
  RECIPIENT_STATUS_UNAVAILABLE: 6
};

goog.object.extend(exports, proto.common);
